import React, { useState, useEffect } from "react";
import { Modal, Form, Input, InputNumber, Switch, Spin, message } from "antd";
import { unwrap } from "../../utils/apiHelpers";
import { fetchBotConfig, updateBotConfig } from "../../services/botApiV3";

/**
 * 假人配置模态框 — 查看和修改 Bot 配置
 */
const ConfigBotModal = ({ visible, bot, loading, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [configLoading, setConfigLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // 打开时加载配置
  useEffect(() => {
    if (visible && bot) {
      loadConfig();
    }
  }, [visible, bot]);

  const loadConfig = async () => {
    if (!bot) return;
    try {
      setConfigLoading(true);
      const data = await unwrap(fetchBotConfig(bot.id));
      form.setFieldsValue(data);
    } catch (error) {
      console.error("获取配置失败:", error);
      message.error("获取配置失败: " + error.message);
    } finally {
      setConfigLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const data = await unwrap(updateBotConfig(bot.id, values));
      message.success(data.message || "配置已更新");
      onSuccess?.();
      onCancel();
    } catch (error) {
      if (error.errorFields) return; // 表单校验失败，不弹 message
      console.error("保存配置失败:", error);
      message.error("保存配置失败: " + error.message);
    } finally {
      setSaving(false);
    }
  };

  if (!bot) return null;

  return (
    <Modal
      title={`假人配置 - ${bot.name || ""}`}
      open={visible}
      onCancel={onCancel}
      onOk={handleSave}
      confirmLoading={saving}
      okText="保存"
      cancelText="取消"
      className="botcontrol-modal"
      width={600}
    >
      <Spin spinning={configLoading} tip="加载配置中...">
        <Form
          form={form}
          layout="vertical"
          style={{ marginTop: 16 }}
        >
          <Form.Item
            label="服务器地址"
            name="host"
            rules={[{ required: true, message: "请输入服务器地址" }]}
          >
            <Input placeholder="mcctian.top" />
          </Form.Item>

          <Form.Item
            label="端口"
            name="port"
            rules={[{ required: true, message: "请输入端口" }]}
          >
            <InputNumber
              min={1}
              max={65535}
              style={{ width: "100%" }}
              placeholder="25565"
            />
          </Form.Item>

          <Form.Item label="自动重连" name="autoReconnect" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item
            label="最大重连次数"
            name="maxReconnect"
            rules={[{ type: "number", min: 0, message: "请输入非负整数" }]}
          >
            <InputNumber min={0} style={{ width: "100%" }} placeholder="5" />
          </Form.Item>

          <Form.Item
            label="重连间隔（毫秒）"
            name="reconnectInterval"
            rules={[{ type: "number", min: 1000, message: "至少 1000ms" }]}
          >
            <InputNumber min={1000} step={1000} style={{ width: "100%" }} placeholder="5000" />
          </Form.Item>

          <Form.Item label="命令前缀" name="commandPrefix">
            <Input placeholder="!" maxLength={10} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ConfigBotModal;
